import * as React from "react";
import "../stylesheets/components/generic/edelweisslogo.scss";
import DeviceContext from "./indentifyDevice";
import { useSelector } from "react-redux";
import name from "../assets/images/generic/nuvama_name_logo.png";
import logo from "../assets/images/generic/nuvama_logo.png";
export function Edelweisslogo() {
    const userName = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.userName; });
    const accountCode = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.accountCode; });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "logo-head-container" },
            localStorage.getItem("sales_native_app") !== "true" && (React.createElement("div", { className: "logo-left" },
                React.createElement("div", { className: "logo" },
                    React.createElement("span", null, DeviceContext().isDesktop ? (React.createElement("img", { src: name, alt: "nuvama", width: 150 })) : (React.createElement("img", { src: logo, alt: "nuvama" })))))),
            (userName != undefined ||
                userName != null ||
                userName != "" ||
                accountCode != undefined ||
                accountCode != null ||
                accountCode != "") && (React.createElement("div", { className: "logo-right" },
                React.createElement("div", { className: "user-account-icon" },
                    React.createElement("div", { className: "icon-background" },
                        " ",
                        React.createElement("i", { className: "edel-icon-user2" }))),
                React.createElement("div", { className: "user-details" },
                    React.createElement("div", { className: "user-username" },
                        userName != undefined && userName != null && userName != ""
                            ? DeviceContext().isDesktop
                                ? userName
                                : localStorage.getItem("sales_native_app") !== "true"
                                    ? userName.toUpperCase().trim().slice(0, 10)
                                    : userName.toUpperCase()
                            : "",
                        React.createElement("span", null, userName != undefined && userName != null && userName != ""
                            ? DeviceContext().isMobile
                                ? localStorage.getItem("sales_native_app") !== "true" && (React.createElement("span", { className: "bluedots" }, "..."))
                                : ""
                            : "")),
                    React.createElement("div", { className: "user-accountid" }, accountCode)))))));
}
